export default __webpack_public_path__ + "static/media/mail-bg-icon-light.9cea0fe9.svg";